export const SURVEY_STATUS = {
  DRAFT: 11,
  LIVE: 22,
  PAUSED: 33,
  CLOSED: 44,
  INVOICE: 55,
};

export const ELIGIBLE_SURVEY_STATUS_INVOICE = [22, 33, 44];

export const SURVEY_STATUS_VALUES = Object.values(SURVEY_STATUS);
